/* eslint-disable new-cap, babel/new-cap */

import { Record } from "immutable"

import { DIRECTIONS } from "../../consts/form"
import PickPrices from "../../records/PickPrices"
import MonthPrices from "../../records/MonthPrices"

const { OUTBOUND, INBOUND } = DIRECTIONS

export const PricesRecord = Record({
  outbound: new PickPrices(),
  inbound: new PickPrices(),
  error: null,
})

// utils
// ===

/**
 * @param form {PricesRecord}
 * @returns {PricesRecord} - clean form
 */
export function clearMonths(form) {
  return form.set(OUTBOUND, new PickPrices()).set(INBOUND, new PickPrices()).set("error", null)
}

// functions
// ===

/**
 * @param form {PricesRecord}
 * @param direction {String} outbound or inbound
 * @param monthId {String} "YYYY-MM"
 * @returns {PricesRecord} - updated form
 */
export function pricesLoadingRequest(form, direction, monthId) {
  return form.set(
    direction,
    form.get(direction).addMonth(monthId, new MonthPrices({ loading: true })),
  )
}

/**
 * @param form {PricesRecord}
 * @param direction {String} outbound or inbound
 * @param monthId {String} "YYYY-MM"
 * @param flights {Array<flight>} flights from this.loadPrices (or FlightsAPI)
 * @returns {PricesRecord} - updated form
 */
export function pricesLoadingSuccess(form, direction, monthId, flights) {
  return form
    .setIn([direction, "months", monthId, "loading"], false)
    .set(direction, form.get(direction).addMonthFlights(monthId, flights))
}

/**
 * @param form {PricesRecord}
 * @param direction {String} outbound or inbound
 * @param monthId {String} "YYYY-MM"
 * @param err {Error} the error of the loading
 * @returns {PricesRecord} - updated form
 */
export function pricesLoadingFailed(form, direction, monthId, err) {
  return form.setIn([direction, "months", monthId, "loading"], false).set("error", err)
}
